/* eslint-disable arrow-parens, max-len, padded-blocks */
import axios from 'axios';
import { getMsalObject } from '@/plugins/msal-plugin';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use(async (config) => {
  // get token through msal and put it in the authorization header
  const bearerToken = await getMsalObject().acquireToken();
  const newConfig = config;
  newConfig.headers.Authorization = `Bearer ${bearerToken}`;
  return newConfig;
});

export default api;
